import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBxAlignJustify = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 17 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M14.5 6.8h-12v2.4h12V6.8ZM14.5 2h-12v2.4h12V2ZM14.5 11.6h-12V14h12v-2.4Z"
	})
});
export default SvgBxAlignJustify;
